/**
 * React component for rendering copyright information with links.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for rendering copyright information.
 * @param {boolean} [props.openInNewTab=false] - Whether to open links in a new tab.
 * @returns {JSX.Element} The rendered CopyRights component.
 */

import React from "react";
import styles from "./StayUpdatedSection.module.scss";
import Link from "next/link";

function CopyRights({ data, openInNewTab=false }) {
  return (
    <div className="lg:flex lg:items-enter lg:justify-between text-center lg:py-[25px] py-[20px] lg:pl-[60px] lg:pr-[80px]">
      <div
        className={`lg:flex lg:items-enter lg:justify-center grid grid-cols-2 lg:gap-[32px] gap-[24px] ${styles.copyRights} lg:pb-0 pb-[20px]`}
      >
        <Link 
          target={openInNewTab ? '_blank' : '_self'}
          href="/terms">{data?.termsOfUseText}</Link>
        <Link 
          target={openInNewTab ? '_blank' : '_self'}
          href="/privacy-policy">{data?.privacyPolicyText}</Link>
        <Link 
          target={openInNewTab ? '_blank' : '_self'}
          href="/warranty">{data?.warrantyText}</Link>
        <Link 
          target={openInNewTab ? '_blank' : '_self'}
          href="/return-policy">{data?.returnPolicyText}</Link>
      </div>
      <div className={`${styles.copyRights}`}>© 2025 Matic. All Rights Reserved.</div>
    </div>
  );
}

export default CopyRights;
